import React from "react";
import { Calendar, Phone, Sparkles } from "lucide-react";
import { CONTACT, HERO_STATS } from "../mock";

const Hero = () => {
  const ytId = CONTACT.youtubeShortId;
  return (
    <section id="home" className="hero">
      <svg className="mandala" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#874B78">
        <circle cx="200" cy="200" r="190" strokeWidth="0.5" />
        <circle cx="200" cy="200" r="150" strokeWidth="0.5" />
        <circle cx="200" cy="200" r="110" strokeWidth="0.5" />
        <circle cx="200" cy="200" r="70" strokeWidth="0.5" />
        <polygon points="200,20 380,310 20,310" strokeWidth="0.5" />
        <polygon points="200,380 20,90 380,90" strokeWidth="0.5" />
        <polygon points="200,60 340,280 60,280" strokeWidth="0.5" />
        <polygon points="200,340 60,120 340,120" strokeWidth="0.5" />
        <circle cx="200" cy="200" r="30" strokeWidth="1" />
      </svg>
      <div className="container">
        <div className="hero-grid">
          <div>
            <div className="hero-eyebrow">
              <Sparkles size={14} /> No. 1 Astrologer in Bangalore
            </div>
            <h1>
              Guiding Souls Through<br/>
              <span className="city">Vedic Wisdom</span>
            </h1>
            <p className="hero-sub">
              {CONTACT.name} — guiding souls through Vedic astrology, palmistry,
              kundali, vastu and spiritual remedies for over 18 years from KR Puram, Bengaluru.
            </p>
            <div className="hero-actions">
              <a href="#consult" className="btn btn-primary">
                <Calendar size={16} /> Book Free Consultation
              </a>
              <a href={`tel:${CONTACT.callNumber}`} className="btn btn-outline">
                <Phone size={16} /> {CONTACT.callDisplay}
              </a>
            </div>
            <div className="hero-stats-row">
              {HERO_STATS.map((s, i) => (
                <div key={i}>
                  <div className="stat-num">{s.num}</div>
                  <div className="stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="hero-video-wrap">
            <div className="hero-video-orbit" />
            <div className="hero-video-phone">
              <div className="phone-notch" />
              <div className="phone-screen">
                <iframe
                  src={`https://www.youtube.com/embed/${ytId}?autoplay=1&mute=1&loop=1&playlist=${ytId}&controls=0&modestbranding=1&rel=0&playsinline=1&showinfo=0`}
                  title="Pandit C. S. Joshi"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  frameBorder="0"
                />
              </div>
              <span className="phone-tag">
                <Sparkles size={12} /> Watch Guruji
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
